// extracted by mini-css-extract-plugin
export var underlinedLink = "_v2-0";